export default "__VITE_ASSET__CHTSaPp0__"